import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaUser, FaUserCircle } from "react-icons/fa";
import { Modal } from "react-bootstrap";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [contactModalShow, setContactModalShow] = useState(false);
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const MobileNavLink = ({ to, text, onClick }) => (
    <Link
      to={to}
      onClick={onClick} // Close menu on click
      className="block py-2 px-4 text-gray-700 hover:bg-gray-200"
    >
      {text}
    </Link>
  );
  
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Main Navbar */}
      <nav className="bg-white shadow-lg fixed top-0 left-0 w-screen z-20">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="grid grid-cols-3 w-full items-center">
            <Link to="/" className="flex items-center justify-start">
              <img
                src={`${process.env.PUBLIC_URL}/assets/metrosacco.png`}
                alt="Metro Sacco Logo"
                className="h-12"
              />
            </Link>

            {/* Main Navigation */}
            <div className="hidden md:flex justify-center space-x-6 flex-nowrap">
              <NavLink to="/" text="HOME" />
              <NavLink to="/#about-us" text="ABOUT" />
              <NavLink to="/products" text="PRODUCTS" />
              <NavLink to="/membership" text="MEMBERSHIP" />
              <NavLink to="/downloads" text="DOWNLOADS" />
              <NavLink to="/calculator" text="LOAN CALCULATOR" className="whitespace-nowrap" />
            </div>


            {/* Login / Dashboard */}
            <div className="flex justify-end">
              {isLoggedIn ? (
                <NavLink to="/user/dashboard" text={`WELCOME, ${currentUser?.name || "USER"}`} />
              ) : (
                <a
                  href="https://memberportal.metro-sacco.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
                >
                  <FaUser className="mr-2" /> LOGIN
                </a>
              )}
            </div>
          </div>

          {/* Mobile Menu Toggle Button */}
          <button
            onClick={toggleMenu}
            aria-label="Toggle Menu"
            className="md:hidden text-gray-700 focus:outline-none"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
              )}
            </svg>
          </button>
        </div>
      </nav>

      {/* Secondary Navbar */}
      <nav className="bg-gray-100 shadow-md fixed top-20 left-0 w-full z-10 border-t border-gray-300">
  <div className="max-w-7xl mx-auto px-6 py-2 flex justify-end space-x-4">
    <NavLink to="/paymentdetails" text="PAYMENT DETAILS" className="text-xs inline-flex items-center px-3 py-1" />
    <NavLink to="/newsandevents" text="NEWS AND EVENTS" className="text-xs inline-flex items-center px-3 py-1" />
    <NavLink to="/faqs" text="FAQ" className="text-xs inline-flex items-center px-3 py-1" />
    <a
      href="https://wa.me/254785278786?text=Hello%2C%20I%20want..."
      className="text-xs inline-flex items-center text-red-600 border border-red-600 px-3 py-1 rounded-md hover:bg-red-600 hover:text-white transition duration-300 ease-in-out"
    >
      Contact Us
    </a>
  </div>
</nav>



<div
  className={`fixed top-0 left-0 w-full h-full bg-white shadow-lg transform ${
    isOpen ? "translate-x-0" : "-translate-x-full"
  } transition-transform duration-300 z-30`}
>
  <button
    onClick={toggleMenu}
    className="absolute top-4 right-4 text-gray-700 focus:outline-none"
  >
    ✖
  </button>
  <div className="px-6 py-8">
    <MobileNavLink to="/" text="HOME" onClick={() => setIsOpen(false)} />
    <MobileNavLink to="/#about-us" text="ABOUT" onClick={() => setIsOpen(false)} />
    <MobileNavLink to="/products" text="PRODUCTS" onClick={() => setIsOpen(false)} />
    <MobileNavLink to="/downloads" text="DOWNLOADS" onClick={() => setIsOpen(false)} />
    <MobileNavLink to="/membership" text="MEMBERSHIP" onClick={() => setIsOpen(false)} />
    <MobileNavLink to="/calculator" text="LOAN CALCULATOR" onClick={() => setIsOpen(false)} />
    {isLoggedIn ? (
      <MobileNavLink
        to="/user/dashboard"
        text={`WELCOME, ${currentUser?.name || "USER"}`}
        onClick={() => setIsOpen(false)}
      />
    ) : (
      <MobileNavLink
        to="https://memberportal.metro-sacco.com/"
        text="LOGIN"
        onClick={() => setIsOpen(false)}
      />
    )}
  </div>
</div>



      {/* Modals */}
      <MembershipModal show={modalShow} onHide={() => setModalShow(false)} />
      <ContactModal show={contactModalShow} onHide={() => setContactModalShow(false)} />
    </>
  );
};

const NavLink = ({ to, text, onClick, className = "" }) => (
  <Link to={to} onClick={onClick} className={`text-sm font-medium text-gray-700 hover:text-green-600 transition-colors ${className}`}>
    {text}
  </Link>
);

const MobileNavLink = ({ to, text, onClick }) => (
  <Link
    to={to}
    onClick={onClick} // Closes menu when a link is clicked
    className="block py-2 px-4 text-gray-700 hover:bg-gray-200"
  >
    {text}
  </Link>
);

const MembershipModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered>
    <div className="bg-white rounded-lg shadow-xl p-8">
      <Modal.Header closeButton>
        <Modal.Title className="text-2xl font-semibold text-gray-800">
          Membership Eligibility and Conditions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>Metropolitan hospital employee</li>
          <li>Ladnan hospital employee</li>
          <li>Former staff of affiliated organization</li>
          <li>Individuals referred by existing members</li>
        </ul>
      </Modal.Body>
    </div>
  </Modal>
);

const ContactModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered>
    <div className="bg-gradient-to-r from-teal-400 to-green-600 rounded-lg shadow-xl p-8">
      <Modal.Header closeButton>
        <Modal.Title className="text-3xl font-bold text-white">
          <FaUserCircle className="mr-3 text-white text-4xl" />
          Contact Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-white">
        <p>Location: Metropolitan Hospital, Buruburu, Nairobi.</p>
        <p>Cell: 0705767492 / 0785278786</p>
        <p>Email: customercare@metro-sacco.co.ke</p>
        <p>
          Website:{" "}
          <a href="http://www.metro-sacco.co.ke" className="text-white underline">
            www.metro-sacco.co.ke
          </a>
        </p>
      </Modal.Body>
    </div>
  </Modal>
);

export default Navbar;
